import { useEffect } from 'react';
import { Download } from 'lucide-react';
import PageLayout from '../components/PageLayout';
import TokenomicsSection from '../components/TokenomicsSection';

const csvData = [
  { allocation: 'Community',          percentage: '20%', tokens: '200,000,000', tge: '50%',  cliff: 'None',      vesting: 'Remainder per schedule' },
  { allocation: 'Ecosystem Rewards',  percentage: '16%', tokens: '160,000,000', tge: '30%',  cliff: 'None',      vesting: 'Remainder per schedule' },
  { allocation: 'Team',               percentage: '15%', tokens: '150,000,000', tge: '0%',   cliff: '12 months', vesting: '24 months linear' },
  { allocation: 'Liquidity',          percentage: '12%', tokens: '120,000,000', tge: '100%', cliff: 'None',      vesting: 'CEX/DEX' },
  { allocation: 'Strategic Round',    percentage: '10%', tokens: '100,000,000', tge: '0%',   cliff: '12 months', vesting: 'Linear' },
  { allocation: 'Marketing',          percentage: '8%',  tokens: '80,000,000',  tge: '25%',  cliff: 'None',      vesting: 'Remainder per schedule' },
  { allocation: 'Treasury',           percentage: '8%',  tokens: '80,000,000',  tge: '0%',   cliff: 'None',      vesting: 'Per schedule' },
  { allocation: 'Reserve',            percentage: '6%',  tokens: '60,000,000',  tge: '0%',   cliff: 'None',      vesting: 'Locked' },
  { allocation: 'Strategic Partners', percentage: '5%',  tokens: '50,000,000',  tge: '0%',   cliff: '12 months', vesting: 'Linear' },
];

const exportCSV = () => {
  const headers = ['Allocation', 'Percentage (%)', 'Token Amount ($SWARM)', 'TGE Unlock', 'Cliff Period', 'Vesting Schedule'];
  const meta = [
    ['SwarmBase ($SWARM) - Tokenomics Export'],
    ['Total Supply: 1,000,000,000 (hard capped, no mint function)'],
    ['Initial Circulating Supply at TGE: 288,000,000 (28.8%)'],
    ['Locked at TGE: 712,000,000 (71.2%)'],
    ['TGE Window: Q3 2026'],
    ['Generated: ' + new Date().toLocaleDateString()],
    [],
    headers,
    ...csvData.map(r => [r.allocation, r.percentage, r.tokens, r.tge, r.cliff, r.vesting]),
  ];
  const csv = meta.map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'swarmbase-tokenomics.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const Tokenomics = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <PageLayout title="Tokenomics">
      {/* CSV export bar */}
      <div className="sticky top-16 z-40 px-5 sm:px-10 py-3 flex items-center justify-end"
        style={{ background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(12px)', borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
        <button onClick={exportCSV}
          className="inline-flex items-center gap-2 px-4 py-2 rounded text-xs font-mono font-semibold transition-all"
          style={{ border: '1px solid rgba(48,213,200,0.35)', color: '#30d5c8', background: 'rgba(48,213,200,0.06)' }}
          onMouseEnter={e => { e.currentTarget.style.background = 'rgba(48,213,200,0.15)'; e.currentTarget.style.borderColor = '#30d5c8'; }}
          onMouseLeave={e => { e.currentTarget.style.background = 'rgba(48,213,200,0.06)'; e.currentTarget.style.borderColor = 'rgba(48,213,200,0.35)'; }}
          data-testid="export-csv-btn">
          <Download size={13} />
          Export CSV
        </button>
      </div>
      <TokenomicsSection />
    </PageLayout>
  );
};

export default Tokenomics;
